import { environment } from '@/config';

export const VashaUtils = {
  isVashaAcademy: (customerCode: string) =>
    environment !== 'production' ||
    customerCode.toLocaleLowerCase() === 'VASHA'.toLocaleLowerCase(),
};
